module.exports = __webpack_public_path__ + "static/media/play-right-gun.8fa45b87.png";